import React from 'react';
import { AuthProvider } from "./hooks/useAuth";
import { CssBaseline, ThemeProvider, Box } from "@mui/material";
import { SnackbarProvider } from "notistack";
import { ApolloProvider, apolloClient } from "./apollo";
import { RouterProvider } from "react-router-dom";
import theme from "./theme";
import router from './routes/router';
import { DrawerProvider } from "./hooks/useDrawerToggle";


function App() {
  const helmetContext = {};
  return (
    <ApolloProvider client={apolloClient}>
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <DrawerProvider>
            <SnackbarProvider maxSnack={3}>
              <CssBaseline />
              <RouterProvider router={router} future={{ v7_startTransition: true }} />
            </SnackbarProvider>
          </DrawerProvider>
        </ThemeProvider>
      </AuthProvider>
    </ApolloProvider>
  );
}

export default App;
